import { ApolloLink, Observable } from "@apollo/client";
const LIMIT = 60000;
/**
 * @see https://sail.stripe.me/data/api/createTimeoutLink
 */ export default function createTimeoutLink() {
    return new ApolloLink(function timeoutLink(operation, forward) {
        return new Observable(function timeoutObserver(observer) {
            const timeout = setTimeout(()=>{
                var _context_observabilityFns;
                const context = operation.getContext();
                var _operation_operationName;
                (_context_observabilityFns = context.observabilityFns) === null || _context_observabilityFns === void 0 ? void 0 : _context_observabilityFns.metrics.increment('frontend.data.long_request', {
                    service: context.service,
                    project: context.queryProject,
                    component: context.component,
                    operation_name: (_operation_operationName = operation.operationName) !== null && _operation_operationName !== void 0 ? _operation_operationName : '<unknown>',
                    operation_prefetch: !!context.isPrefetchMode,
                    operation_deduplicate: !!context.isDeduplicated
                });
            }, LIMIT);
            const subscription = forward(operation).subscribe({
                next: function timeoutObserverNext(result) {
                    clearTimeout(timeout);
                    return observer.next(result);
                },
                error: function timeoutObserverError(error) {
                    clearTimeout(timeout);
                    return observer.error(error);
                },
                complete: function timeoutObserverComplete() {
                    clearTimeout(timeout);
                    return observer.complete();
                }
            });
            return function timeoutObserverUnsubscribe() {
                if (subscription) {
                    subscription.unsubscribe();
                }
            };
        });
    });
}

//# sourceMappingURL=createTimeoutLink.js.map